/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {theme} from "../../../constants/theme";
import {BiUser, BiUserX} from "react-icons/bi";
import {useMsal} from '@azure/msal-react';
import {ARGOS_ROUTES} from "../../../Routes/constants";
import useGetCurrentPath from "../../../hooks/useGetCurrentPath";
import {useState} from "react";
import * as colors from "../../../constants/colors"
import {IconButton, Menu, MenuItem, Tooltip} from '@mui/material';

export const shouldShowHeader = (route) => {
  const val = ARGOS_ROUTES.find(item => item.path === route)
  return val?.headerTitle ?? false
}
const getHeaderTitle = (route) => {
  const val = ARGOS_ROUTES.find(item => item.path === route)
  return val?.headerTitle ?? ''
}

const Header = () => {
  const {instance, accounts} = useMsal();
  const currentPath = useGetCurrentPath()
  const showHeader = shouldShowHeader(currentPath);
  const title = getHeaderTitle(currentPath)
  //const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [inHover, setHover] = useState(false);
  const handleLogout = () => {

    setAnchorEl(null);
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
    //navigate("/home")
  }
  return (
    <>
      {showHeader && (
        <div style={{
          display: "flex",
          backgroundColor: theme.layout.header.backgroundColor,
          alignItems: "center",
          height: theme.layout.header.height
        }}>
          <div style={{width: '1px', backgroundColor: 'white', height: '80%', alignSelf: 'center'}}></div>
          <span style={{color: "white", fontSize: "25px", paddingLeft: "20px"}}> {title} </span>
          <span style={{color: "white", marginLeft: 'auto', marginRight: 6}}>
          <Tooltip title="LOGOUT" arrow placement="top">
            <IconButton
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
              sx={{"&:hover": {color: colors.x11Gray}}}
              onClick={(event) => setAnchorEl(event.currentTarget)}
              color="inherit"
            >
              {inHover ? <BiUserX style={{height: '45px', width: '35px',color: colors.x11Gray}}/> :
                <BiUser style={{padding: '5px', height: '45px', width: '35px'}}/>}
            </IconButton>
          </Tooltip>
          <strong>{accounts[0] && accounts[0].name}</strong>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={open}
              onClose={() => setAnchorEl(null)}
            >
              <MenuItem sx={{
                color: colors.baseBlue, fontSize: theme.font.button.size, whiteSpace: 'nowrap',
                maxWidth: 'max-content'
              }} dense
                        onClick={() => handleLogout()}>LOGOUT</MenuItem>
            </Menu>
          </span>
        </div>
      )}
    </>
  )
}

export default Header
